import { useScreenState } from 'components/Screen';
import { useQueryCache } from 'query';

import { chart } from './queryKeyFactory';

export const useChartDataUpdatedAt = () => {
  const screenState = useScreenState();
  const { dataUpdatedAt }: any = useQueryCache(
    chart({
      metrics: screenState.metrics,
      filters: screenState.filters,
    }),
    {
      exact: true,
    }
  );

  return dataUpdatedAt;
};
